<template>
    <div>
        <div class="title">Recurring SMS Campaign Overview</div>
        <sms-campaign-details v-if="campaign.id" :campaign="campaign" />
    </div>
</template>

<script>
    import SmsCampaignDetails from '@/components/recurring/SMSCampaignDetails.vue'
    import recurringSmsCampaignService from '@/services/recurring-sms-campaign-service'
    export default {
        components: { SmsCampaignDetails },
        data() {
            return {
                campaign: {}
            }
        },
        created() {
            this.fetchSMSCampaignById(this.$route.params.campaignId)
        },
        methods: {
            fetchSMSCampaignById(id) {
                recurringSmsCampaignService.getSMSCampaignById(id).then(resp => {
                    this.campaign = resp.data
                })
            }
        }
    }
</script>

<style scoped>

.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 15px;
    width: 90%;
}

.form-field {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

</style>
